<template>
    <button 
        class="tooltip"
        type="button"
        @click="isOpen = !isOpen"
        @mouseenter="isOpen = true"
        @focus="isOpen = true"
        @mouseleave="isOpen = false"
        @blur="isOpen = false"
        :aria-describedby="`tooltip-${id}`"
        aria-label="More information"
    >
        {{ label }}
        <div class="tooltip__content" :class="{ 'tooltip__content--open': isOpen }" :id="`tooltip-${id}`" role="tooltip">
            <slot></slot>
        </div>
    </button>
</template>

<script setup>
    import { ref } from "vue";

    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: '?'
        }
    });

    const isOpen = ref(false);
</script>

<style scoped>
    .tooltip {
        display: inline-block;
        position: relative;
        cursor: help;
        border-radius: 50%;
        height: 18px;
        width: 18px;
        font-size: 10px;
        background: none;
        border: .25px solid;
        margin: 0 .5rem;
        vertical-align: middle;
        line-height: 10px;
        color: #488684;
    }

    .tooltip__content {
        display: none;
        background: #fff;
        border: 1px solid #ccc; 
        padding: 1rem;
        position: absolute;
        top: 50%;
        left: 50%;
        max-width: 350px;
        width: max-content;
        z-index: 1;
        transform: translate(0px, -35%);
        font-size: .8rem;
    }

    .tooltip__content--open {
        display: block;
    }
</style>